module.exports = __webpack_public_path__ + "img/plankgaming.7438118d.svg";